import { defineComponent, toRef, computed } from "vue";
import { u as useColors } from "../../../../composables/useColors-cd2c0b98.mjs";
import { u as useTextColor } from "../../../../composables/useTextColor-19f6bd95.mjs";
const _sfc_main = defineComponent({
  name: "VaDropdownContent",
  props: {
    noPadding: { type: Boolean, default: false },
    background: { type: String, default: "background-secondary" },
    textColor: { type: String }
  },
  setup(props) {
    const { getColor } = useColors();
    const { textColorComputed } = useTextColor(toRef(props, "background"));
    const computedStyle = computed(() => ({
      background: getColor(props.background, void 0, true),
      color: textColorComputed.value,
      padding: props.noPadding ? 0 : void 0
    }));
    return { computedStyle };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=VaDropdownContent.vue_vue_type_script_lang-1a7d5776.mjs.map
